import { useAtomValue } from 'jotai';
import { userRejectedPaymentsAtom } from '../atoms';
import { usePaymentProviders } from '../api/queries';

export function usePaymentAcceptance() {
  const userRejectedPayments = useAtomValue(userRejectedPaymentsAtom);
  const { data: paymentData } = usePaymentProviders();

  const isAvailable = paymentData?.isAvailable ?? false;
  const isPaymentsAccepted = isAvailable && !userRejectedPayments;

  return {
    isPaymentsAccepted,
    isShowAcceptPayments: isAvailable,
  };
}
